// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// Import jQuery FIRST - expose-loader will make it globally available
import $ from 'jquery';

// Make jQuery available globally for legacy code
window.jQuery = $;
window.$ = $;

// Import select2 after jQuery is global
import 'select2';
import 'select2/dist/css/select2.css';

// Now that jQuery is global, we can require files that depend on it
require("custom/jquery.pineput");
require("custom/mailcheck.min");

// Initialize select2 on document ready
$(document).ready(function() {
  if ($.fn.select2) {
    $('.select2').select2();
  }
});

require("@rails/ujs").start();
require("@rails/activestorage").start();
require("channels");
//= require highcharts
//= require chartkick

import "chartkick/highcharts"
import "@hotwired/turbo-rails";
require("custom/classListShim.js");
require("controllers");
Turbo.setFormMode("off")

// Don't import tw-elements JavaScript since we're only using jQuery for modals
// The Tailwind plugin in tailwind.config.js handles the CSS styles
// If we need TailwindElements JS components later, we can import them selectively

import "stylesheets/application.scss"
if (navigator.serviceWorker) {
  navigator.serviceWorker.register('/service-worker.js', { scope: './' })
    .then(function(reg) {
      console.log('[Companion]', 'Service worker registered!');
      console.log(reg);
    });
}
// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
